import {RouterModule, Routes} from '@angular/router';
import {
  AsignacionSemanaComponent,
  ListaSemanasComponent,
  PresupuestoSemanaComponent,
  PresupuestoXDiaSemanaComponent
} from './components/semana.component';
import {NgModule} from '@angular/core';
import {MisTiendasComponent, TiendaXSemanaComponent} from './components/tienda.component';
import {AsignHorarioComponent} from './components/horario.component';
import {DetalleEmpleadoComponent} from './components/detalle.empleado.component';
import {ListaPlanAccionComponent, VerPlanAccionComponent} from './components/plan.accion.component';
import {FriedmanSecurityServices} from './services/friedman.security.services';
import {ReportesComponent} from './reportes/reportes.component';
import {InconsistenciaSemanaComponent} from './components/inconsistencia.semana.component';
import {MultiplesMallasTiendasComponent} from './components/multiples.mallas.tiendas.component';

const friedmanRoutes: Routes = [
  {path: 'semanas/malla', component: AsignacionSemanaComponent, canActivate: [FriedmanSecurityServices]},
  {path: 'semanas/presupuestos', component: PresupuestoSemanaComponent, canActivate: [FriedmanSecurityServices]},
  {path: 'semanas/pptodia', component: PresupuestoXDiaSemanaComponent, canActivate: [FriedmanSecurityServices]},
  {path: 'semanas/inconsistencia', component: InconsistenciaSemanaComponent, canActivate: [FriedmanSecurityServices]},
  {path: 'tienda/:id', component: TiendaXSemanaComponent},
  {path: 'tienda/empleado/:id', component: DetalleEmpleadoComponent},
  {path: 'horarios', component: AsignHorarioComponent},
  {path: 'semanas', component: ListaSemanasComponent},
  {path: 'mistiendas', component: ListaSemanasComponent},
  {path: 'mistiendas/planes', component: ListaPlanAccionComponent},
  {path: 'mistiendas/planes/:id', component: VerPlanAccionComponent},
  {path: "semanas/multiplesmallas", component: MultiplesMallasTiendasComponent, canActivate:[FriedmanSecurityServices]}
  // {path: 'reportes', component: ReportesComponent}
];


@NgModule({
  imports: [RouterModule.forChild(friedmanRoutes)],
  exports: [RouterModule]
})
export class FriedmanRoutingModule {
}
